export enum WebviewOpenSection {
  BRAIN_DUMP = 'braindump'
}
